'use client';

import React from 'react';
import { Lightbulb } from 'lucide-react';

/**
 * Small, reusable help callout for guiding users at the moment they need it.
 * Use `HelpTipList` for a titled set of best-practice tips, or `HelpTip` for a
 * single inline hint.
 */

export function HelpTipList({
  title = 'Tips for best results',
  tips,
  className = '',
}: {
  title?: string;
  tips: string[];
  className?: string;
}) {
  if (tips.length === 0) return null;
  return (
    <div className={`rounded-lg border border-primary/15 bg-primary/5 px-3 py-2.5 ${className}`}>
      <div className="flex items-center gap-1.5 mb-1.5">
        <Lightbulb size={13} className="text-primary" />
        <span className="text-xs font-700 text-primary">{title}</span>
      </div>
      <ul className="space-y-1">
        {tips.map((tip, i) => (
          <li key={i} className="flex gap-1.5 text-[11px] leading-relaxed text-muted-foreground">
            <span className="text-primary mt-px">•</span>
            <span>{tip}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

export function HelpTip({ children, className = '' }: { children: React.ReactNode; className?: string }) {
  return (
    <div className={`flex items-start gap-1.5 text-[11px] leading-relaxed text-muted-foreground ${className}`}>
      <Lightbulb size={12} className="text-primary mt-px shrink-0" />
      <span>{children}</span>
    </div>
  );
}
